import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {useSelector} from "react-redux";
import {Industry} from "../firebase/index.js";


export const inMemoryIndustrySliceName = "inMemoryIndustry";

const inMemoryIndustrySlice = createSlice({
	  name: inMemoryIndustrySliceName,
	  initialState: {industry: null},
	  reducers: {
			 setInMemoryIndustry: (state, action: PayloadAction<{ industry: Industry }>) => {
					state.industry = action.payload.industry;
			 }
	  }
});

export const {setInMemoryIndustry} = inMemoryIndustrySlice.actions;

const inMemoryIndustryReducer = inMemoryIndustrySlice.reducer;
export default inMemoryIndustryReducer;


export function useInMemoryIndustry(): Industry {
	  return useSelector((state) => state[inMemoryIndustrySliceName].industry);
}